import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { setIsRoomHost, setRoomId, setIdentity, setIsRoomListener, setIsShowOverlay } from '../../stories/actions';
import { getIsRoomExists, getRoomListener } from '../../services/api';
import { toast } from "react-toastify";

import Label from '../Labels/Label';
import ButtonSwitche from '../Buttons/ButtonSwitche';

import "./Home.css";

const InputJoinRoom = ({ authToken, usuarioId, username, avatar, setIsRoomHostAction, setRoomIdAction,
    setIdentityAction, setIsRoomListenerAction, setIsShowOverlayAction, isCheckListener }) => {
    const [roomId, setRoomId] = useState("");

    const navigateTo = useNavigate();

    const handlerChangeRoomId = (event) => {
        const value = event.target.value;
        setRoomId(value);
    };

    const handlerKeyDownRoomId = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();

            handlerEnterJoinRoom();
        }
    };

    const notify = (message) => {
        toast(message);
    };

    const handlerCreateNewRoom = async () => {
        if (authToken) {
            setIsRoomHostAction(true);
            setIdentityAction(username);
            setIsRoomListenerAction(false);
            setIsShowOverlayAction(true);

            navigateTo(`/room?session=${authToken}&host=${true}`);
        }
    };

    const handlerEnterJoinRoom = async () => {
        if (roomId) {
            const roomResponse = await getIsRoomExists(roomId);
            const { roomExists, full } = roomResponse;

            if (roomExists) {
                if (full) {
                    notify("A sala está em uso no momento. Por favor, tente novamente mais tarde.");
                } else {
                    setRoomIdAction(roomId);
                    setIsRoomHostAction(false);
                    setIdentityAction(username);
                    setIsRoomListenerAction(false);
                    setIsShowOverlayAction(true);

                    await getRoomListener(roomId, username, usuarioId, false, avatar, isCheckListener);

                    navigateTo(`/room?session=${authToken}&host=${false}`);
                }
            } else {
                notify("Sala não encontrada. Estamos trabalhando para resolver isso o mais rápido possível.");
            }
        } else {
            notify("O código informado é inválido. Por favor, tente novamente.");
        }
    };

    return (
        <div className='row input_join_room_container'>
            <div className='col-md-12 mb-2'>
                <Label text="CRIE OU ENTRE EM UMA SALA" />
            </div>

            {(roomId && roomId.length > 5) && <ButtonSwitche paragraph="Permitir ouvintes" />}

            <div className='col-md-12 mb-4'>
                <div className='input_group_container'>
                    <span
                        title='Criar uma nova sala'
                        onClick={handlerCreateNewRoom}
                        className="material-symbols-outlined btn_icon_circle">add</span>

                    <input
                        type='text'
                        value={roomId}
                        placeholder='Insira o código aqui...'
                        onChange={handlerChangeRoomId}
                        onKeyDown={handlerKeyDownRoomId}
                        className='form-control input_theme_style'
                    />

                    <span
                        title='Participar de uma sala existente'
                        onClick={handlerEnterJoinRoom}
                        className="material-symbols-outlined btn_icon_circle">start</span>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        ...state
    };
};

const mapStateActionToProps = (dispatch) => {
    return {
        setRoomIdAction: (roomId) => dispatch(setRoomId(roomId)),
        setIdentityAction: (identity) => dispatch(setIdentity(identity)),
        setIsRoomHostAction: (isRoomHost) => dispatch(setIsRoomHost(isRoomHost)),
        setIsRoomListenerAction: (isRoomListener) => dispatch(setIsRoomListener(isRoomListener)),
        setIsShowOverlayAction: (isShowOverlay) => dispatch(setIsShowOverlay(isShowOverlay))
    };
};

export default connect(mapStateToProps, mapStateActionToProps)(InputJoinRoom);